<template>
  <div class="wrapper reply-item">
    <span class="reviewer" @click.stop="showUser(reply.PassportId)">
      {{reply.NiCheng}}
    </span>
    <span v-if="reply.HuifuDetails" @click.stop="showUser(reply.HuifuDetails.PassportId)">
      <span>回复</span>
      <span class="reviewer">{{reply.HuifuDetails.NiCheng}}</span>
    </span>
    <span>:</span>
    <span class="" v-for="(txt,textIndex) in handlePlaceholder(reply)" :key="textIndex">
      <span class="" v-if="isString(txt)">{{txt}}</span>
      <span class="user quote" v-if="txt.Type == 19" :data-passportid="txt.Code"
       @click.stop="showUser">
        {{txt.Text}}</span>
      <span class="topic quote" v-if="txt.Type == 18">{{txt.Text}}</span>
      <span class="fund quote" v-if="txt.Type == 1" @click.stop="lintto(txt)" >{{txt.Text}}</span>
      <span class="pic" v-if="txt.Type == 100" @click.stop="showGallery" :data-img='txt.PicImg'>
        {{txt.Text}}
      </span>
      <img
        :src="txt.emoji"
        class="emoji"
        v-if="txt.emoji"
      />
    </span>
  </div>
</template>

<script>
import Util from '@/base/Util';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'reply',
  props: {
    reply: Object,
  },
  data() {
    return {
      album: [],
    };
  },
  methods: {
    isString(val) {
      return Object.prototype.toString.call(val).slice(8, -1) === 'String';
    },
    handlePlaceholder(val) {
      let textBooms = val.TextEnd.split(/(\[\W+?\]|<!--\w+-->)/).filter((item) => item.trim() !== '');
      for (let i = 0, len = textBooms.length; i < len; i += 1) {
        for (let j = 0, jlen = val.ReplyKeyWords.length; j < jlen; j += 1) {
          if (val.ReplyKeyWords[j].Label === textBooms[i]) {
            textBooms[i] = val.ReplyKeyWords[j];
            break;
          }
        }
      }
      textBooms = Util.emojiName(textBooms);
      return textBooms;
    },
    showGallery(e) {
      const [, src] = e.target.dataset.img.match(/"(.*)"/);
      const imgArr = [].concat(src.trim());
      this.$root.handleGallery(imgArr);
    },
    showUser(param) {
      if (typeof param === 'string') {
        const passportid = param;
        this.linkToUserHome(passportid);
      } else {
        const { passportid } = param.currentTarget.dataset;
        this.linkToUserHome(passportid);
      }
    },
    lintto(item) {
      //
      const { LinkType, LinkTo } = item.AppUrl;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
    },
    linkToUserHome(passportid) {
      detailPushPage({
        name: 'avatorClick',
        type: 1,
        url: `fund://page/personalhome?passportid=${passportid}`,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.reply-item {
  font-size: 28px;
  line-height: 38px;
  margin-top: 20px;
  display:-webkit-box;
  overflow:hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp:2;
  -webkit-box-orient:vertical;
  .reviewer, .review {
    color: #4c618f;
  }
  .quote {
    color: #4c618f;
  }
  .user {
    color: #4c618f;
  }
}

.emoji {
  width: 38px;
  height: 38px;
  vertical-align: middle;
  margin-left: 7px;
}

</style>
